exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".z-Xf1LQC2defmvRS1Sw6r{margin-top:10px}.efoLQEnCMKd2AQChThEAw{margin-bottom:10px}a.bXOnjS1VU-bciY8Kl3tuv{color:#fa6400;padding:4px 8px;visibility:hidden}._1tcAtRie8bclZAIzUI-dQF:hover a.bXOnjS1VU-bciY8Kl3tuv{visibility:visible;color:#fa6400}@media screen and (max-width: 800px){a.bXOnjS1VU-bciY8Kl3tuv{display:none}.z-Xf1LQC2defmvRS1Sw6r{display:none}}\n", ""]);

// Exports
exports.locals = {
	"expando": "z-Xf1LQC2defmvRS1Sw6r",
	"spinner": "efoLQEnCMKd2AQChThEAw",
	"expandoButton": "bXOnjS1VU-bciY8Kl3tuv",
	"ExpandoCard": "_1tcAtRie8bclZAIzUI-dQF"
};